import {
  InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
  FC,
  ChangeEvent,
} from 'react';

// import Calendar from 'react-calendar';

import { useField } from '@unform/core';
import { IconBaseProps } from 'react-icons';
import { FiAlertCircle } from 'react-icons/fi';

import { Container, Error } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  containerStyle?: object;
  icon?: React.ComponentType<IconBaseProps>;
  fontSize?: number | string;
}

const InputDate: FC<InputProps> = ({
  name,
  containerStyle = {},
  icon: Icon,
  fontSize,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null); // HTMLInputElement - vai dar ao inputRef as propriedades de um input

  const [isFocused, setIsFocused] = useState(false); // Se esta com foco
  const [isFilled, setIsFilled] = useState(false); // Se esta preenchido
  const [className, setClassName] = useState<'empty' | 'filled'>('empty');

  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);

    // Verifica se o inputRef tem um valor/value. Se tiver preenchido = true. Se tiver vazio = false. !! Tranforma o value em booleano.
    setIsFilled(!!inputRef.current?.value); // inputRef pega o valor direto do Input. document.querySelector('input') e etc.
  }, []);

  const handleChangeInput = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    setClassName((value as string) ? 'filled' : 'empty');
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container
      style={containerStyle}
      isErrored={!!error}
      isFilled={isFilled}
      isFocused={isFocused}
    >
      {Icon && <Icon size={20} />}

      <input
        onFocus={handleInputFocus} // Receber o foco
        onBlur={handleInputBlur} // Perder o foco
        onChange={handleChangeInput}
        defaultValue={defaultValue}
        type="date"
        max="2100-12-31"
        ref={inputRef}
        className={className}
        style={{ fontSize }}
        {...rest}
      />

      {error && (
        <Error title={error}>
          <FiAlertCircle color="#c53030" size={20} />
        </Error>
      )}
    </Container>
  );
};

export default InputDate;
